import axios from 'axios';

export default {
    setupInterceptors: ( history:any) => {
        axios.interceptors.request.use(function (config) {
            let Token:any= localStorage.getItem('Token')  || localStorage.getItem('TokenLimit') ;
            config.headers= { 'Content-Type': 'application/json' };
            config.headers = { Authorization: Token ?  Token : '' };


            return config;
        }, function (error) {
            return Promise.reject(error);
        });

        axios.interceptors.response.use(response => {
            return response;
        }, error => {

            if (error.response.status === 401) {

            }

            if (error.response.status === 404) {
                // history.push('/not-found');
            }

            return Promise.reject(error);
        });
    },
};
